<template>
  <div>
    <h1 class="text-danger">Hello from About Component!</h1>
  </div>
</template>

<script>
export default {
  name: 'aboutComponent',
  // Add component logic here if needed
}
</script>

<style scoped>
/* Add styles specific to this component here */
</style>
